import { render, staticRenderFns } from "./AddUpdateFoodTable.vue?vue&type=template&id=321591e1"
import script from "./AddUpdateFoodTable.vue?vue&type=script&lang=js"
export * from "./AddUpdateFoodTable.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateFoodTable.vue?vue&type=style&index=0&id=321591e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports